import React from "react";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import "dayjs/locale/zh-cn";
import { createRoot } from "react-dom/client";

interface AppInitOptions {
  rootHtml?: string;
}

// 应用初始化（antd 中文与主题在 App.tsx 的 ConfigProvider 统一配置）
export function AppRoot(App: React.ReactNode, options?: AppInitOptions) {
  dayjs.extend(customParseFormat);
  dayjs.extend(advancedFormat);
  dayjs.extend(weekday);
  dayjs.extend(localeData);
  dayjs.extend(weekOfYear);
  dayjs.extend(weekYear);
  dayjs.extend(isoWeek);
  dayjs.locale("zh-cn");

  const root = createRoot(document.getElementById(options?.rootHtml || "root") as HTMLElement);

  root.render(<React.StrictMode>{App}</React.StrictMode>);
}
